import React, { FC, useCallback, useContext, useMemo } from "react";
import "./ColumnStatusChange.css"
import DropDownSelect, { IListItemDropDown } from "../../UiLib/DropDownSelect/DropDownSelect";
import { AppContext } from "../../../App";
import { BoardContext } from "../../../contexts/BoardContext";
import { IColumnDisplay } from "../../../common/api_interfaces/column/IColumnDisplay";

interface IColumnStatusChangeProps {
    column?: IColumnDisplay;
    currentStatus?: number;
    onEditStatus: (status: number) => void;
    edit: boolean;
}

const ColumnStatusChange: FC<IColumnStatusChangeProps> = ({
    column,
    currentStatus,
    onEditStatus,
    edit
}) => {
    const boardContext = useContext(BoardContext);
    const { showToast } = useContext(AppContext);

    const statuses = useMemo<IListItemDropDown[]>(() => 
        boardContext.allStatusColumn.map(xx => ({ id: xx.id, itemName: xx.name }))
    , [boardContext.allStatusColumn]);

    const currentStatusValue = useMemo(() => 
        column?.status ?? currentStatus
    , [column?.status, currentStatus]);

    const handleSelectStatus = useCallback((id: number) => {
        if (currentStatusValue === id) {
            showToast("Нельзя выбрать текущий статус!");
            return;
        }

        if (!edit) {
            showToast("Редактирование столбцов запрещено!");
            return;
        }

        onEditStatus(id);
    }, [currentStatusValue, edit, showToast, onEditStatus]);

    return (
        <div className="column__status--change__component">
            <div>
                <p>Статус тикетов</p>
            </div>
            <div>
                <DropDownSelect 
                    id={1} 
                    callBack={handleSelectStatus} 
                    listItem={statuses} 
                    currentChoise={currentStatusValue}
                    openDropDown={edit}
                    
                />
            </div>
        </div>
    );
}

export default React.memo(ColumnStatusChange);